export const FirebaseConfig = {
	"projectId": "micmic-74696",
	"appId": "1:638905804119:web:85a787023bbde10d5b4a12",
	"databaseURL": "https://micmic-74696-default-rtdb.firebaseio.com",
	"storageBucket": "micmic-74696.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCXX-i-oSvZVrkRE5mgx_V9BGoqmW1vsK0",
	"authDomain": "micmic-74696.firebaseapp.com",
	"messagingSenderId": "638905804119",
	"measurementId": "G-V042VNG44Y"
};